import { spawn } from 'redux-saga/effects';

import { sagas as get } from './getModule';
import { sagas as bulkAttachDetach } from './bulkAttachDetachModule';

export default function* zoneSagas() {
	yield spawn(get);
	yield spawn(bulkAttachDetach);
}
